<template>

<div class="container question_container" :class="[{hasError: isError}, $mq]" >
    <div class="content">
      <div class="progression">{{questionIdx+1}} / {{questionsCount}}</div>
      <h3 class="question_title" v-html="applySmartquotes($options.filters.translategrader(question.question, $i18n.locale))"></h3>

      <survey-choices
        :question="question"
        :questionAnswered="action"
        :questionIdx="questionIdx"
        :pageIdx="pageIdx"
        :color="color"
        @answer-validated="goToNextAnswer"
        />
    </div>
</div>

</template>


<script>

import smartquotes from 'smartquotes';
import SurveyChoices from './survey_elements/SurveyChoices.vue'
// import SurveyHtml from './survey_elements/Html.vue'
// import SurveyRadiogroup from './survey_elements/Radiogroup.vue'
// import SurveyText from './survey_elements/Text.vue'

export default {
  name: 'QuizElement',

  props: ['question', "action", "questionIdx", "questionsCount", "color", "pageIdx"],

  components: {
    SurveyChoices,
  },

  computed: {
      isError: function () {
          // return this.showMissing && this.question.isRequired && this.surveyResults[this.question.name] === undefined;
          return false;
      },

      // Styles
      font_color: function(){
          var bgColor= this.color;
          return {
            "color": bgColor
          }
      }
  },

  mounted: function() {
    // console.log("mounted");
    this.$el.style.setProperty('--colorCategory', this.color) ;
  },
  updated: function() {
    // console.log("updated");
    this.$el.style.setProperty('--colorCategory', this.color) ;
  },

  methods: {

    applySmartquotes(a) {
        a = smartquotes(a);
        a = a.replace(/\u201c/g, "\u00AB\&nbsp;");
        a = a.replace(/\u201d/g, "\&nbsp;\u00BB");
        a = a.replace(/(\w) \?/g, '$1&nbsp;?'); // add nb spaces before '?'
        return a;
      },

    getWidgetComponentName(element) {
      console.log(element);
        if (element.customWidget) {
          return "survey-customwidget";
        }
        return "survey-" + element.questionType.toLowerCase();
      },

    goToNextAnswer(element){
      this.$emit('answer-validated');
    }

  }


}
</script>



<style>

  .answerChoice {
    width: 47%;
    display: inline-block;
    margin: 10px;
  }


  @media only screen and (max-width: 914px) {
    .answerChoice {
      width: 92%;
    }
  }
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hasError{
  box-shadow: 2px 6px 9px rgba(200, 0, 0, 0.4);
}

.content {
  width: 100%;
}

.question_container {
  /* Screen height - header - action bar footer - 2 x 'next' chevrons*/
  height: calc(100vh - 112px - 52px - 2 * 72px);
  display: flex;
  align-items: center;
}

.progression {
  font-family: 'Nunito', sans-serif;
  font-size: 14px;
  text-align: center;
}

.question_title {
  text-align: center;
  margin: 0 auto;
  max-width: 830px;
  color: #051e41;
  font-family: 'Nunito', sans-serif;
  font-weight: bold;
  font-size: 25px;
}

@media only screen and (max-width: 1023px) {
  .question_title {
    font-size: 22px;
  }
}

@media only screen and (max-width: 991px) {
  .question_title {
    font-size: 20px;
  }
}

@media only screen and (max-width: 480px) {
  .question_title {
    font-size: 18px;
  }

  .question_container {
    height: calc(100vh - 72px - 42px - 2 * 69px);
    display: flex;
    align-items: center;
  }
}

.question_container.sm {
  height: calc(100vh - 72px - 52px - 2 * 38px);
}

.question_container.sm ..progression {
  font-size: 12px;
}
.question_container.sm .question_title{
  font-size: 15px;
}


</style>



// WEBPACK FOOTER //
// src/components/QuizElement.vue